export { default } from './SyncAlternate'
